export default __webpack_public_path__ + "static/media/twitter.inline.65dbbcf6.svg";